import { ref } from 'vue';

export function useResizer() {
    const sidebarWidth = ref(250);
    const articleListHeight = ref(600);
    const articleSummaryHeight = ref(300);
    const articleListWidth = ref(450);

    const startResizingVertical = (event, contentAreaRef) => {
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();

        const isTouch = event.type === 'touchstart';
        const startX = isTouch ? event.touches[0].clientX : event.clientX;
        const startWidth = sidebarWidth.value;
        const mainContent = contentAreaRef?.parentElement;
        const totalWidth = mainContent?.offsetWidth || window.innerWidth;

        const onMove = (e) => {
            const clientX = e.type && e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
            const dx = clientX - startX;
            let newWidth = startWidth + dx;

            const minWidth = 120;
            const maxWidth = totalWidth - 100;
            newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
            sidebarWidth.value = newWidth;
        };

        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onUp);
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove);
        document.addEventListener('touchend', onUp);
    };

    const startResizingHorizontal = (event, contentAreaRef) => {
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();

        const isTouch = event.type === 'touchstart';
        const startY = isTouch ? event.touches[0].clientY : event.clientY;
        const startHeight = articleListHeight.value;
        const totalHeight = contentAreaRef?.offsetHeight || window.innerHeight;
        const dividerHeight = 5;

        const onMove = (e) => {
            const clientY = e.type && e.type.startsWith('touch') ? e.touches[0].clientY : e.clientY;
            const dy = clientY - startY;
            let newHeight = startHeight + dy;

            const minHeight = 100;
            const maxHeight = totalHeight - minHeight - dividerHeight;
            newHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));

            articleListHeight.value = newHeight;
            articleSummaryHeight.value = totalHeight - newHeight - dividerHeight;
        };

        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onUp);
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove);
        document.addEventListener('touchend', onUp);
    };

    const startResizingArticleList = (event, contentAreaRef) => {
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();

        const isTouch = event.type === 'touchstart';
        const startX = isTouch ? event.touches[0].clientX : event.clientX;
        const startWidth = articleListWidth.value;
        const totalWidth = contentAreaRef?.offsetWidth || window.innerWidth;
        const dividerWidth = 5;

        const onMove = (e) => {
            const clientX = e.type && e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
            const dx = clientX - startX;
            let newWidth = startWidth + dx;

            const minWidth = 200;
            const maxWidth = totalWidth - 200 - dividerWidth;
            newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));

            articleListWidth.value = newWidth;
        };

        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onUp);
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove);
        document.addEventListener('touchend', onUp);
    };

    // Initial Layout calculation
    const initLayout = (contentAreaEl) => {
        if (contentAreaEl) {
            const h = contentAreaEl.offsetHeight;
            if (h > 0) {
                articleListHeight.value = Math.floor(h * 0.7);
                articleSummaryHeight.value = h - articleListHeight.value - 5;
            }
        }
    };

    return {
        sidebarWidth,
        articleListHeight,
        articleSummaryHeight,
        articleListWidth,
        startResizingVertical,
        startResizingHorizontal,
        startResizingArticleList,
        initLayout
    };
}
